import React, { useEffect, useState } from "react";
import "../AboutMe.css";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import LanguageIcon from "@material-ui/icons/Language";
import GitHubIcon from "@material-ui/icons/GitHub";
import WorkIcon from "@material-ui/icons/Work";

function AboutMe() {
  useEffect(() => {
    document.title = "About me";
  }, []);

  const scrollToTop = () => {
      window.scrollTo(0,1);
  }

  useEffect(() => {
    scrollToTop();
  });

  return (
    <div className="aboutme">
      <h1 className="aboutme-header">Who am I?</h1>
      <div className="container">
        <div className="animate__animated animate__zoomInUp">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-4">
              <div className="aboutme-img">
                <img
                  src={process.env.PUBLIC_URL + "/images/about/slika10.jpg"}
                  alt="Web Dev Logo"
                />
              </div>
            </div>
            <div className="col-md-7">
              <div className="aboutme-text">
                <p>
                  Hi, my name is Daniel. I am 16 years old and currently
                  attending economics school in Pula. In general, I like to say
                  I have a lot of hobbies, including cycling, speedcubing,
                  playing the piano, or ethnic hacking, but coding and
                  programming have become little more than a hobby over time.
                </p>
                <p>
                  I’ve always been interested in computer science and I’ve
                  always tried to understand how things work. This is exactly
                  why I became interested in ethnic hacking, after which I moved
                  on to web application development, my biggest passion.
                </p>
              </div>
            </div>
          </div>
          <h1 className="skills-header">My skills</h1>
          <div className="row skills-images">
            <div className="col-md-2">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika.png"}
                alt="HTML logo"
              />
            </div>
            <div className="col-md-2">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika1.png"}
                alt="CSS logo"
              />
            </div>
            <div className="col-md-2">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika2.png"}
                alt="JS logo"
              />
            </div>
            <div className="col-md-2">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika3.png"}
                alt="React.js logo"
              />
            </div>
            <div className="col-md-2 skills-images-php text-center">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika4.png"}
                alt="Boostrap logo"
              />
            </div>
            <div className="col-md-2">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika5.png"}
                alt="MaterialUI logo"
              />
            </div>
          </div>
          <div className="row history-one align-items-center">
            <div className="col-md-6 history-one-text">
              <h1>How I started coding?</h1>
              <p>
                A few years ago, I became interested in ethnic hacking and
                devoted a lot of time to it. I learned to use Linux and its
                terminal, Metasploit framework, Nmap and many other tools, and
                after that I discovered HTML. I soon became very interested and
                knew how to sit at the computer for hours and study it.
              </p>
              <p>
                In parallel, I started learning CSS and it opened up a whole new
                perspective on things for me. I started, practically without any
                experience, working on one project, and with it, I started a
                story about PHP. I understood the exact difference between a
                backend and a frontend, and my desire to learn was increasing.
              </p>
            </div>
            <div className="col-md-6 history-one-img-coding">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika6.jpg"}
                alt="Coding"
              />
            </div>
          </div>
          <div className="row history-two align-items-center">
            <div className="col-md-6 history-two-dis">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika7.png"}
                alt="DIS login photo"
              />
            </div>
            <div className="col-md-6 history-two-text">
              <h1>My first project</h1>
              <p>
                Without any experience, I started working on one small
                information system, my first project. I learned during its
                creation and put into practice all the knowledge I had gathered.
                Although it seems very simple to me today, it will always be my
                first project and an indicator of my interest in web application
                development.
              </p>
              {/* <Link to="/dis" className="dis-system-link btn btn-primary">
                <LanguageIcon /> More about DIS
              </Link> */}
              <a
                href="https://github.com/danielbradaric/dis_system"
                className="dis-system-link btn btn-primary"
                target="_blank"
              >
                <LanguageIcon /> More about DIS
              </a>
            </div>
          </div>
          <div className="row history-three align-items-center">
            <div className="col-md-6 history-three-text">
              <h1>Learning, learning and more learning...</h1>
              <p>
                As this part became more and more interesting to me, I continued
                to study patiently and diligently invest all my resources in web
                development. As a sequel, I started learning a JavaScript
                language whose principle and use I really liked from the
                beginning. I saw it power and immediately set to work.
              </p>
              <p>
                At this stage of learning, I have already discovered a lot of
                interesting websites and technologies that I can use. These
                include MaterialUI, Firebase, Google Fonts, API keys, and more,
                and the React.js framework has come as a big deal.
              </p>
            </div>
            <div className="col-md-6 history-three-img">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika8.jpg"}
                alt="Web dev"
              />
            </div>
          </div>
          <h1 className="now-header">Where I am now?</h1>
          <div className="row now align-items-center">
            <div className="col-md-6 now-img">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika9.png"}
                alt="Big Tech Company"
              />
            </div>
            <div className="col-md-6 now-text">
              <p>
                Today I am very pleased with everything I have achieved. I still
                have a lot of things and technology to learn, but I know I’m
                ready for them and can handle them without a problem. I feel
                like I’ve done a lot in a short amount of time and I’m learning
                more every day and getting better.
              </p>
              <p className="now-text-p2">
                I really like that and I enjoy coding and I think I can do a
                really good job. Although I also know the back-end, during my
                studies I focused more on the front-end and I think I have the
                potential to succeed in that part because that is really my
                biggest passion!
              </p>
              <Link to="portfolio" className="portfolio">
                Portfolio <ArrowForwardIcon />
              </Link>
            </div>
            <div className="now-portfolio-active">
              <Link to="portfolio" className="portfolio-active">
                Portfolio <ArrowForwardIcon />
              </Link>
            </div>
          </div>
          <div className="social-media-header">
            <h1>Check out my social media</h1>
          </div>
          <div className="row social-media align-items-center justify-content-center">
            <div className="col-md-6">
              <img
                src={process.env.PUBLIC_URL + "/images/about/slika11.jpg"}
                alt="Social media logo"
              />
            </div>
            <div className="col-md-6">
              <p>
                On the following links, you can check out my social media
                profiles where you can find more info about me. As well, you can
                check my GitHub profile where you can see all my projects and
                their full code.
              </p>
              <p>
                Also, if you are interested in collaborating, contact me via my
                freelancer.com profile to create top web applications together
                and make the internet a better place!
              </p>
              <div className="social-media-btn-container">
                <a
                  href="https://github.com/danielbradaric"
                  className="social-media-btn btn btn-success"
                  target="_blank"
                >
                  <GitHubIcon /> GitHub
                </a>
                <a
                  href="https://www.freelancer.com/u/danielbradaric"
                  className="social-media-btn btn btn-primary"
                  target="_blank"
                >
                  <WorkIcon /> Freelancer.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="button-container">
        <Link to="/contact" className="contact-link">
          Contact <ArrowForwardIcon />
        </Link>
      </div>
    </div>
  );
}

export default AboutMe;
